import React, { Component } from 'react';
import { DialogContainer } from 'react-md';

import { NavigationDrawer } from 'react-md';

import MathJax from '../../components/react-mathjax-preview';
import { Swiper, Slide } from 'react-dynamic-swiper'
// import 'react-dynamic-swiper/lib/styles.css'
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import TextEditor from '../../components/TextEditor'
import { Button, Tooltip } from '@mui/material';
import { stateToHTML } from 'draft-js-export-html';
import "./explanation.css"
import { HiOutlineZoomIn, HiOutlineZoomOut } from "react-icons/hi";

const defaultImageWidth = 350;

let options = {
  // blockRenderers: {
  //   unstyled: (block) => {
  //     let data = block.getData();

  //     let blockText = block.getText();
  //     if(blockText.trim() === '') //bug-tracker#264
  //       return '';
  //     let style = '';
  //     if( data.includes('ALIGN_CENTER'))
  //       style = "style='text-align:center;'"
  //     if(data.includes('ALIGN_RIGHT'))
  //       style = "style='text-align:right;'"
  //     if(data.includes('ALIGN_LEFT'))
  //       style = "style='text-align:left;'"
  //     return '<p '+style+'>' + blockText + '</p>'
  //   },
  // }, 
  blockStyleFn : (block) => {
    let data = block.getData();
    if (data.size == 0) return;

    let style = {};
    if (data.get('text-align')) style = { ...style, textAlign: data.get('text-align') }
    return  {
      attributes: {
        dir: 'auto'
      },
      style
    };
  },
  entityStyleFn: (entity) => {
    const entityType = entity.get('type').toLowerCase();
    //console.log("entityType",entityType);

        if (entityType === 'image') {
      const data = entity.getData();
      ////console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;

      const float = data.alignment || data.float || data.dataVal;

      let style = {}
      let className = ""

      if (float === 'center') {
        className = "custom-image-align-center"
        style = {
          display: 'block',
          marginLeft:'auto',
          marginRight: 'auto',
        }
      } else {
        className = `custom-image-align-${float}`
        if (float) {
          style = {
            float: float
          }
        }
      }

      return {
        element: 'img',
        attributes: {
          src: data.src,
          className: className,
        },
        style: {
          width: computedWidth+'%',
          ...style,
        },
      };
    }
     if (entityType === 'draft-js-video-plugin-video') {
      const data = entity.getData();
      ////console.log('image-data',data);
      let computedWidth = data.width;
      if(computedWidth === undefined)
      computedWidth = 30;
      return {
        element: 'iframe',
        attributes: {
          src: data.src,
          width: 420,
          height: 315,
          allowfullscreen: '',
        }
      };
    } 
  },
};

// var navItemsArray = [];
export default class ExplanationGallery extends Component {


  constructor(props) {
    super(props)
    this.state = {
      startTimeHashMap: {},
      endTimeHashMap: {},
      exp_name: [],
      activeIndex: -1,
      navItemsArray: [],
      imageWidthArr: [],
      showZoomButton: false,
    }
    this.closeClick = this.closeClick.bind(this);
    this.captureTime = this.captureTime.bind(this);
    this.moveToSlide = this.moveToSlide.bind(this);

    
  }
  componentDidMount() {
    this.captureTime();
    this.setState({
      activeIndex: 0,
    })
    if(this.props.explanations && this.props.explanations.length) {
      // let navItemsArray = [];
       let updatedWidthArr = [];
      for (let i = 0; i < this.props.explanations.length; i++) {
        let expl = this.props.explanations[i];
       /*  navItemsArray.push({
          primaryText: this.props.explanations[i].explanation_name,
          active: i === this.state.activeIndex,
          style: i === this.state.activeIndex ? { backgroundColor: '#dadbdc', color: '#bb0000', fontWeight:500 } : {},
          onClick: () => this.moveToSlide(i)
        }); */
        let obj = {
            id: `${expl.subject_id}_${expl.topic_id}_${expl.category_id}_${expl.topic_id}_${expl.explanation_id}`,
            width: defaultImageWidth,
        }
        updatedWidthArr.push(obj);
      }
      this.setState({
        // navItemsArray,
        imageWidthArr: updatedWidthArr,
      })
    }
  }

   checkIfTextContainsAnImage = (text) => {
        if (text === undefined || text === null || text === "") return false;
        return text.includes("<img") && text.includes("</img>")
    }

  componentDidUpdate(_, prevState) {
    if (prevState.activeIndex !== this.state.activeIndex) {
      let navItemsArray = [];
      for (let i = 0; i < this.props.explanations.length; i++) {
        navItemsArray.push({
          primaryText: this.props.explanations[i].explanation_name,
          active: i === this.state.activeIndex,
          style: i === this.state.activeIndex ? { backgroundColor: '#dadbdc', color: '#bb0000', fontWeight:500 } : {},
          onClick: () => this.moveToSlide(i)
        });
      }

       let activeExplanation = this.props.explanations[this.state.activeIndex];
      if (activeExplanation.text !== undefined && activeExplanation.text !== null && activeExplanation.text.trim() !== "") {
          let text = this.convertToHTML(activeExplanation);
          this.setState({
            showZoomButton: this.checkIfTextContainsAnImage(text)
          });
      }

      this.setState({
        navItemsArray,
      })
    }
  }

  captureTime(isClose = false) {

    var tempStartTime = new Date();
    console.debug("new time =", this.state.newtime);

    var temp_name = this.props.explanations?.map(exp => exp.explanation_name);
    console.debug("explanation data =", temp_name);
    this.setState({
      exp_name: temp_name
    });
    var mySwiper = document.querySelector('.swiper-container').swiper
    console.log("Active Index and Previous Index  ", mySwiper.activeIndex, mySwiper.previousIndex)
    var startTimeHashMap = this.state.startTimeHashMap;
    var endTimeIndex = mySwiper.previousIndex;
    if (isClose === false) {
      var tempStartTimeArr = [];


      if (startTimeHashMap[mySwiper.activeIndex] !== undefined &&
        startTimeHashMap[mySwiper.activeIndex] !== null) {
        tempStartTimeArr = startTimeHashMap[mySwiper.activeIndex];
      }

      tempStartTimeArr.push(tempStartTime);

      startTimeHashMap[mySwiper.activeIndex] = tempStartTimeArr;
    }
    else {
      endTimeIndex = mySwiper.activeIndex;
    }
    var endTimeHashMap = this.state.endTimeHashMap;


    if (endTimeIndex !== undefined &&
      endTimeIndex !== null) {
      var tempEndTimeArr = [];


      if (endTimeHashMap[endTimeIndex] !== undefined &&
        endTimeHashMap[endTimeIndex] !== null) {
        tempEndTimeArr = endTimeHashMap[endTimeIndex];
      }

      tempEndTimeArr.push(tempStartTime);

      endTimeHashMap[endTimeIndex] = tempEndTimeArr;
    }
    this.setState({
      startTimeHashMap: startTimeHashMap,
      endTimeHashMap: endTimeHashMap
    });
  }
  closeClick() {
    this.captureTime(true);

    this.props.elapsedTime(this.state.startTimeHashMap, this.state.endTimeHashMap);
    this.props.closeClick();
  }
  convertToHTML(exp) {
    let retVal = "";
    try {
      /* retVal = TextEditor.getHTMLStringFromEditorState(
        EditorState.createWithContent(
          convertFromRaw(JSON.parse(exp.text)))).toString('html', null); */
      if (exp.text === null || exp.text === undefined || exp.text === "") return retVal;
      const contentState = convertFromRaw(JSON.parse(exp.text));
      const editorState = EditorState.createWithContent(contentState);

     /*  const options = {
        blockRenderers: {
          'atomic': (block) => {
            if (block.getEntityAt(0) === null) return "";
            const entity = contentState.getEntity(block.getEntityAt(0));
            
            const entityData = entity.getData();
            const entityType = entity.getType();
            console.debug("entityType>>??", entityType, entityData, entity)
            if (entityType === 'draft-js-video-plugin-video') {
              return `<iframe src="${entityData.src}" width="420" height="315" allowfullscreen></iframe>`;
            }

            if (entityType === 'IMAGE') {
              return `<img src="${entityData.src}" />`;
            }
      
            return null;
          }
        },
      }; */

      retVal = stateToHTML(editorState.getCurrentContent(), options);

      
      if (exp.alt_explanation_text !== undefined && exp.alt_explanation_text !== null && exp.alt_explanation_text !== "") {
        //alt feedback text
/*         console.debug(exp.alt_explanation_text)
        console.debug("hello") */
        var tempDisplayExplanationText = retVal
        var altExplanationText = exp.alt_explanation_text
        altExplanationText = altExplanationText.replace(/\n/ig, ' ')
        //finding number of time image present
        var altExplanationTextCount = altExplanationText.split(';').length
        var ExplanationImgTagCount = tempDisplayExplanationText.split('<img').length - 1
        // console.debug("altExplanationTextCount ,ExplanationImgTagCount ",altExplanationTextCount,ExplanationImgTagCount,randomQuestion.answers.length-1)
        console.debug((altExplanationTextCount / 2), "==", ExplanationImgTagCount)
        if ((altExplanationTextCount / 2) == ExplanationImgTagCount) {
          if (ExplanationImgTagCount >= 1) {
            console.debug("Answer greater than 1")
            var altExplanationTextArr = altExplanationText.split(';');
            var lastPosOfImg = 0
            // console.debug("altanswer",altExplanationTextArr)
            for (var j = 0; j <= altExplanationTextArr.length - 1; j = j + 2) {
              // console.debug(j)
              lastPosOfImg = tempDisplayExplanationText.indexOf("<img", lastPosOfImg)
              lastPosOfImg = lastPosOfImg + 4
              var b = "  title =\"" + altExplanationTextArr[j] + "\"  alt =\"" + altExplanationTextArr[j + 1] + "\" "
              var output = [tempDisplayExplanationText.slice(0, lastPosOfImg), b, tempDisplayExplanationText.slice(lastPosOfImg)].join('');
              tempDisplayExplanationText = output
              // console.debug("answertest", j, " ", tempDisplayExplanationText)
            }
          }
        }
        retVal = tempDisplayExplanationText
      }
      //alt feedback text

    }
    catch (err) {
      console.error(err.message);
    }
    return retVal;
  }

  moveToSlide(index) {
   /*  this.setState({
      activeIndex: index,
    }) */
    console.debug("the current explanation clicked is  ", index)
    var mySwiper2 = document.querySelector('.swiper-container').swiper
    mySwiper2.slideTo(index, 1500);

  }

  handleQuestionResize = (type) => {

      let obj = this.state.imageWidthArr[this.state.activeIndex];
      let doc = document.getElementById(`expl-${this.state.activeIndex}`);
      if (doc) {
        let images = doc.querySelectorAll('img');
        if (images && images.length) {
            obj.width = type === "plus" ? obj.width + 100 : obj.width - 100;
            images.forEach(img => {
                img.style.setProperty('width', `${obj.width}px`, 'important');

                if (img.classList.contains("custom-image-align-right")) {
                    if (obj.width >= 700) {
                        img.style.setProperty('float', "none", "important")
                    } else {
                        img.style.setProperty('float', "right", "important")
                    }
                }
                if (img.classList.contains("custom-image-align-left")) {
                    if (obj.width >= 700) {
                        img.style.setProperty('float', "none", "important")
                    } else {
                        img.style.setProperty('float', "left", "important")
                    }
                }

            });
            let updatedImageWidthArr = this.state.imageWidthArr;
            updatedImageWidthArr[this.state.activeIndex] = obj;
            this.setState({
               imageWidthArr: updatedImageWidthArr
            })
        }
      }
    }

  render() {
    let floatFooter = {
      position: 'fixed',
      bottom: '0px',
      width: '100%',
      backgroundColor: 'white',
      float: 'left',
      zIndex: '1',
    };


    return (

      <DialogContainer

        visible={this.props.visibility}
        fullPage
        width={'100%'}
        className='explanation-dialog'
        focusOnMount={false}>

          {this.state.showZoomButton ? 
          <div className='sf-image-resize-btn-div'>
            <Tooltip placement="top" arrow title="Magnify all images within this explanation">
                <div className="sf-image-resize-btn cursor-pointer"
                    style={{
                        fontSize: "3rem !important"
                    }}
                    onClick={() => {
                            this.handleQuestionResize("plus")
                        }}
                    >
                    <HiOutlineZoomIn fontSize={25}/>
                </div>
              </Tooltip>
              <Tooltip placement="top" arrow title="Shrink all images within this explanation">
                <div className="sf-image-resize-btn cursor-pointer"
                    onClick={() => {
                        this.handleQuestionResize("minus")
                    }}
                >
                    <HiOutlineZoomOut fontSize={25} />
                </div>
              </Tooltip>
          </div>
          : null}

        <NavigationDrawer
          drawerHeader={<div style={{ padding: "20px", background:'#bb0000' }}><h2 className="text-color-white">Explanations</h2></div>}
          navItems={this.state.navItemsArray}
          desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
          includeDrawerHeader={true}
          // navClassName="navListStyle"
          // toolbarClassName="toolbarHeader"
          
        >

          <div>
            {this.props.explanations !== null ?

              <Swiper
                navigation={true}
                pagination={false}
                slideChange={this.captureTime}
              >

                {
                  this.props.explanations?.map((exp, i) => {
                    return (
                      <Slide key={i}
                       onActive={swiper => {
                          if (swiper) {
                            this.setState({activeIndex: swiper.realIndex});
                          }
                      }}
                      >
                        <div 
                          id={`expl-${i}`}
                          style={{
                              width: '99%',
                              position: 'relative',
                              height: "100%",
                              overflowY: 'auto',
                              padding:'0 1rem'
                          }}>
                          <center className=''>
                              <h2>{exp?.explanation_name}</h2>
                              {exp.text !== undefined && exp.text !== null && exp.text.trim() !== "" ? 
                                <MathJax style={{ textAlign: "left",  }} math={this.convertToHTML(exp)} />
                              : null}
                          </center>
                          </div>
                      </Slide>
                    )
                  }

                  )}
              </Swiper>

              : ""
            }</div>
        </NavigationDrawer>
        <div style={{
          position:'fixed',
          bottom: "6px",
          left: 0,
          width:'100%',
          zIndex: 99,
        }}>


            <center>
            <Button variant='contained' size='small' onClick={this.closeClick}>
              Close
            </Button>
            </center>

        </div>
      </DialogContainer>

    );
  }

}
